import { Component, OnInit } from '@angular/core';
import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'bm-col-header-cell',
  templateUrl: './col-header-cell.component.html',
  styleUrls: ['./col-header-cell.component.scss']
})
export class ColHeaderCellComponent implements OnInit, IHeaderAngularComp {

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {}

  name: string;
  orderBy: string;
  direction: number;

  agInit(params) {
    this.name = params.column.colDef.headerName;
  }

  ngOnInit() {

    this.activatedRoute.queryParamMap.subscribe(params => {
      this.orderBy = params.get('orderBy');
      this.direction = +params.get('direction');
    });

  }

  setSort(direction) {
    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: {orderBy: this.name, direction},
        queryParamsHandling: 'merge',
      });
  }

}
